import React, { FC } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import { LatLngExpression } from 'leaflet'
import { Box } from '@mui/material'
import { IPosition } from 'src/generated-types'

export interface EmptyMapProps {
  position?: IPosition[]
  zoomControl?: boolean
  attributionControl?: boolean
}
const EmptyMap: FC<EmptyMapProps> = ({
  position = [60.472, 8.4689],
  zoomControl = false,
  attributionControl = false,
}) => {
  return (
    <Box width="100%" height={'100%'} data-test-id="map-empty-state">
      <MapContainer
        center={position as LatLngExpression}
        zoom={5}
        scrollWheelZoom={false}
        className="w-full h-full rounded-lg"
        zoomControl={zoomControl}
        attributionControl={attributionControl}
      >
        <TileLayer
          attribution='&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <TileLayer
          attribution="Map data &copy; Kartverket"
          url="https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=norgeskart_bakgrunn&zoom={z}&x={x}&y={y}"
        />
      </MapContainer>
    </Box>
  )
}
export default EmptyMap
